<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div id="cookie" v-if="show">
        <div class="cookie-popup">
            <div id="cookie-close" @click="show = false">&times;</div>
            <div class="cookie-container">
                <p>
                    {{ text }}
                    <router-link :to="`${file}.${format}`" target="_blank">{{ file_name }}</router-link
                    >.
                </p>
                <button id="cookie-to-accept" class="btn" @click="toAcceptCookie()">{{ btn_name }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            text: "Мы используем cookies для быстрой и удобной работы сайта. Продолжая пользоваться сайтом, вы принимаете",
            file: "Политика_обработки_персональных_данных_Zaman",
            format: "pdf",
            file_name: "условия обработки персональных данных",
            btn_name: "Принять",
            show: false,
            cookie: localStorage.getItem("cookie") ?? false,
        };
    },
    methods: {
        toAcceptCookie() {
            this.show = false;
            localStorage.setItem("cookie", true);
        },
    },
    mounted() {
        if (this.cookie) {
            this.show = false;
        } else {
            setTimeout(() => {
                this.show = true;
            }, 2000);
        }
    },
};
</script>

<style lang="scss" scoped>
.cookie-popup {
    position: fixed;
    bottom: 20px;
    right: 0;
    left: 0;
    z-index: 999;
    width: fit-content;
    height: auto;
    background: #fff;
    font-size: 14px;
    line-height: 20px;
    color: #000;
    margin: auto;
    box-shadow: 0 0 5px rgb(0, 0, 0, 0.5);
    border-radius: 20px;
    @media (max-width: 768px) {
        margin: 0 15px;
    }
    p {
        white-space: pre-line;
        a {
            text-decoration: underline;
            color: inherit;
        }
    }
    .cookie-container {
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 10px 20px;
    }
}
#cookie-close {
    display: flex;
    justify-content: flex-end;
    font-size: 24px;
    cursor: pointer;
    position: relative;
    top: 10px;
    right: 10px;
}
#cookie-to-accept {
    background-color: #2a374b;
    width: fit-content;
    height: 35px;
    padding: 0 20px;
    font-size: 14px;
    margin-top: 10px;
    color: #fff;
    &:hover,
    &:focus {
        background-color: #cf603f;
        transition: 0.2s ease 0.2s;
    }
}
</style>
